import { Icon } from "@elaniintc/goes-design-system";
import type { EventForDay } from "../utils/utils";
import { cn } from "@/utils/theme";

const EventBadge = ({ event }: { event: EventForDay }) => {
  const isBlocked = ["HOLIDAY", "NON_WORKING_DAY", "WEEKEND"].includes(
    event.type,
  );

  return (
    <div
      className={cn(
        "cursor-pointer flex items-center justify-between text-xs rounded-md h-5 overflow-hidden mb-1",
        isBlocked
          ? "bg-surface-warning-accent text-warning"
          : "bg-surface-info-accent text-info",
      )}
    >
      <div className="flex items-center gap-1 flex-1 min-w-0 px-2">
        <Icon
          type="fa"
          name="calendar-xmark"
          size="sm"
          className={cn(isBlocked ? "text-warning" : "text-info")}
        />
        <span className="truncate flex-1 font-bold" data-testid="event-badge">
          {event.name}
        </span>
      </div>

      {event.dayLabel !== "1/1" && (
        <div
          className={cn(
            "px-1 h-full flex items-center",
            isBlocked
              ? "bg-surface-warning-accent-click"
              : "bg-surface-info-accent-click",
          )}
        >
          <span className="font-bold">{event.dayLabel}</span>
        </div>
      )}
    </div>
  );
};

export default EventBadge;
